<script>
import { Line } from "vue-chartjs";

export default {
  name: "DifotLineChart",
  extends: Line,
  props: ['yearlabels', 'chartyear'],
  mounted() {
    this.renderLineChart();
  },
  methods: {
    renderLineChart(){
      this.renderChart(
        {
          labels: this.yearlabels,
          datasets: [
            {
              label: this.chartyear[0].label,
              data: this.chartData,
              backgroundColor: this.chartyear[0].backgroundColor,
              borderWidth: this.chartyear[0].borderWidth,
              borderColor: "rgba(1, 116, 188, 0.50)",
              pointBackgroundColor: "rgba(171, 71, 188, 1)"
              
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
            }],
          }
        }
      );
    }
  },
  computed: {
    chartData(){
      return this.chartyear[0].data.map(Number);
    }
  }
};
</script>